module.exports = __webpack_public_path__ + "static/img/Video.b89c4e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobizone/imgs/browse/Video.jpg
// module id = 1560
// module chunks = 0